<template>
  <div id="nav">
    <div class="logo" >
        <div
          class="logoPic animate__animated animate__rubberBand"
        />
        <div class="topnav">
          <input id="menu" type="checkbox"/>
          <div class="anniu">
            <label for="menu"><span>
              <img src="../assets/images/new/更多.svg"></span>
            </label>
          </div>
          <el-menu
            :default-active="$route.path"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
            style="width:800px;margin-top:33px"
            :class="{'hidden': !visible}"
          >
            <el-menu-item index="/">
              首页
            </el-menu-item>
            <el-menu-item index="/warehouse/wconcept">
              医药共享仓
            </el-menu-item>
            <el-menu-item index="/gygd/gdyy">
              关于固德
            </el-menu-item>
            <el-submenu index="3">
              <template slot="title">
                企业动态
              </template>
              <el-menu-item index="/news/qyxw">
                企业新闻
              </el-menu-item>
              <el-menu-item index="/news/hyxw">
                行业新闻
              </el-menu-item>
              <el-menu-item index="/news/gsgg">
                公司公告
              </el-menu-item>
              <el-menu-item index="/news/flfg">
                法律法规
              </el-menu-item>
            </el-submenu>
            <el-menu-item index="/recruit/zpgw">
              招贤纳士
            </el-menu-item>
            <el-menu-item index="/contactus">
              联系我们
            </el-menu-item>
            <el-menu-item @click="toShop()">
              在线商城
            </el-menu-item>
          </el-menu>
        </div>

    </div>

    <div class="Division" />
    <div>
      <div class="top clearfix" />
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        visible: true, // 控制导航栏显示或隐藏
        activeIndex: '/home',
        // prevScrollpos: window.pageYOffset,
      };
    },
    // mounted() {
    //   window.addEventListener('scroll', this.handleScroll);
    // },
    // beforeDestroy() {
    //   window.removeEventListener('scroll', this.handleScroll);
    // },
  methods: {
    handleSelect(key, keyPath) {
      this.$router.push(key)
    },
    goHome() {
      this.$router.push('/')
    },
    toShop() {
      window.location.href = 'https://shop.goodyiyao.com/'
    },
  }
}

</script>
<style>
.anniu span{
  display: none;
  cursor: pointer;
}
  input{
    display: none;
  }
  .topnav .el-menu-demo {
      display: block;
    }
  input:checked + .el-menu-demo {
    display: block;
  }
    .el-menu-item{
      font-size: 15px!important;
    }
    .topnav .el-menu--horizontal>.el-menu-item,.topnav .el-menu--horizontal>.el-submenu .el-submenu__title,.el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-submenu__title{
      color: #6e6e6e!important;
      font-size:15px!important;
    }
    .el-menu-demo .el-menu-item{
      padding: 0;
      width: 114px;
      text-align: center
    }
    body>.el-menu--horizontal{
      top: 103px!important;
    }
    .el-menu--horizontal>.el-menu-item.is-active{
      border-bottom-color: transparent!important;
    }
    .el-menu--horizontal>.el-menu-item{
      height: 45px!important;
      line-height: 45px!important;
    }
    .el-menu--horizontal>.el-submenu .el-submenu__title{
      height: 45px!important;
      line-height: 45px!important;
    }
    .el-menu--horizontal>.el-menu-item.is-active,.el-menu--horizontal .el-menu-item:not(.is-disabled):focus, .el-menu--horizontal .el-menu-item:not(.is-disabled):hover,.el-submenu__title:hover,.topnav .el-submenu.is-active .el-submenu__title{
      color: #0069FF!important;
    }
    .el-menu--horizontal>.el-submenu{
      text-align: center;
      width: 114px;
    }
    .el-menu--horizontal{
      min-width: 114px;
    }
    .el-menu--horizontal>.el-submenu.is-active .el-submenu__title{
      border-bottom-color:transparent!important;
    }
    .el-menu.el-menu--horizontal{
      border-bottom: none!important;
    }
  #nav{
      display: flex;
      width: 100%;
      border-bottom: 2px solid #76bd25;
      justify-content: center;
  }
  .logo{
    width: 1200px;
    background: #fff;
    height: 105px;
    font-size: 16px;
    cursor: pointer;
    display: flex;
    z-index: 5;
    justify-content: space-around;
  }
  .logoPic{
    width: 200px;
    height: 105px;
    background: url('../assets/images/logogw.png') 5px center no-repeat;
    background-size: auto 55px;
  }
  .topnav{
    display: flex;
  }
  .anniu{
    display: flex;
    padding-right: 60px;
  }

  @media (max-width: 1200px){
    .anniu span{
      display: block; 
    }
    .topnav{
      flex-direction: column;
    }
    .topnav .el-menu-demo{
      width: 100px !important;; 
      display: none;
      flex-direction: column; /* 竖向排列 */
      position: absolute;
      background: #fff;
      text-align: center;
      box-shadow: 0 2px 5px rgba(0,0,0,0.1);
      z-index: 1000;
      top:30px
    }
    .logo{
      justify-content: space-between;
    }
      /* 隐藏桌面端导航栏 */
    /* .el-menu--horizontal {
      display: none;
    } */

    /* 移动端按钮样式 */
  .anniu {
    display: flex;
    align-items: center;
    padding-left: 85px;
    padding-top: 35px;
  }
    /* 点击按钮显示菜单 */
    #menu:checked ~ .el-menu-demo {
      display: block !important;
      z-index: 9999 !important;
    }
    body>.el-menu--horizontal{
      top: 230px!important;
    }
  }
</style>